export default __webpack_public_path__ + "static/media/bina-gray.701fb706.svg";